import { forwardRef } from 'react';
import type { IconifyIcon } from '@iconify/react';
// icons
import { Icon } from '@iconify/react';
import type { BoxProps } from '@mui/material';
// @mui
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

export type IconifyProps = {
    icon: IconifyIcon | string;
    width?: number | string;
    sx?: BoxProps['sx'];
};

// forwardRef is kept because MUI passes refs through to this icon (Tooltip, IconButton).
const Iconify = forwardRef<HTMLElement, IconifyProps>(({ icon, width = 20, sx, ...other }, ref) => (
    <Box ref={ ref } component={ Icon } icon={ icon } sx={ { width, height: width, ...sx } } { ...other } />
));

export default Iconify;
